import React, { useEffect, useState } from "react";
import api, { formatTanggal } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import AbsensiCalendar from "@/components/AbsensiCalendar";
import { ABSENSI_STATUS } from "@/lib/constants";

function StatusBadge({ status }) {
  const s = ABSENSI_STATUS.find((x) => x.v === status);
  if (!s) return <span className="pp-badge-danger">{status === "tidak_hadir" ? "Tidak Hadir" : status || "—"}</span>;
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${s.cls}`}>{s.label}</span>;
}

export function AbsensiOrtu() {
  const [items, setItems] = useState([]);
  const [view, setView] = useState("calendar");
  useEffect(() => { (async () => { try { const { data } = await api.get("/absensi"); setItems(data); } catch (e) { console.error(e); } })(); }, []);
  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Absensi Siswa" action={
        <div className="flex gap-1 bg-slate-100 p-1 rounded-lg">
          <button onClick={() => setView("calendar")} className={`px-3 py-1.5 text-xs rounded-md ${view === "calendar" ? "bg-white shadow-sm text-slate-900 font-semibold" : "text-slate-600"}`} data-testid="view-calendar">Kalender</button>
          <button onClick={() => setView("list")} className={`px-3 py-1.5 text-xs rounded-md ${view === "list" ? "bg-white shadow-sm text-slate-900 font-semibold" : "text-slate-600"}`} data-testid="view-list">Tabel</button>
        </div>
      } />

      {view === "calendar" ? (
        <AbsensiCalendar records={items} title="Riwayat Kehadiran Anak" />
      ) : (
      <section className="pp-card overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="pp-table-header">
            <th className="text-left px-5 py-3">Tanggal</th><th className="text-left px-5 py-3">Guru Pendamping</th><th className="text-left px-5 py-3">Keterangan</th>
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={3} className="text-center py-10 text-slate-400 italic">Belum ada absensi.</td></tr>}
            {items.map(a => (
              <tr key={a.id} className="pp-row">
                <td className="px-5 py-3 font-mono text-xs">{formatTanggal(a.tanggal)}</td>
                <td className="px-5 py-3 text-slate-600">{a.nama_guru}</td>
                <td className="px-5 py-3"><StatusBadge status={a.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      )}
    </Layout>
  );
}
